import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10 19h10.5"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M6.605 17.25V19M6.605 5.25V7"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.686 8.923c-.2-.885-1.343-1.871-3.015-1.871-1.671 0-2.957 1.086-2.957 2.457 0 3.114 6.2 1.514 6.2 5.129 0 1.306-1.571 2.414-3.243 2.414-1.67 0-2.828-1.029-3.171-2.129"
    })
  ]))
}